var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canRead
    ? _c(
        "el-card",
        { staticClass: "package-receipt-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "receipt-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("包裹确认收货")]),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    loading: _vm.loading,
                    disabled: _vm.loading || _vm.saving,
                  },
                  on: { click: _vm.loadStatus },
                },
                [_vm._v("刷新状态")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "receipt-state",
              attrs: {
                role: "status",
                "aria-live": "polite",
                "aria-busy": _vm.loading || _vm.saving,
              },
            },
            [
              _c(
                "div",
                { staticClass: "receipt-controls" },
                [
                  _vm.canSave ? _c("span", [_vm._v("开关设置：")]) : _vm._e(),
                  _vm.canSave
                    ? _c("el-switch", {
                        attrs: {
                          value: !!(_vm.status && _vm.status.configuredEnabled),
                          disabled: _vm.mutationDisabled,
                          "aria-checked": _vm.status
                            ? _vm.status.configuredEnabled
                              ? "true"
                              : "false"
                            : undefined,
                          "aria-label": "包裹确认收货",
                          "aria-describedby": "package-receipt-note",
                        },
                        on: { change: _vm.changeEnabled },
                      })
                    : _vm._e(),
                  _c("span", [_vm._v("当前状态：")]),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type:
                          _vm.status && _vm.status.enabled ? "success" : "info",
                      },
                    },
                    [_vm._v(_vm._s(_vm.statusText))]
                  ),
                  _vm.loading || _vm.saving
                    ? _c("span", { staticClass: "receipt-note" }, [
                        _vm._v(
                          _vm._s(
                            _vm.loading ? "正在读取状态…" : "正在处理，请稍候…"
                          )
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm.error || _vm.notice
                ? _c(
                    "p",
                    { class: ["receipt-note", { "receipt-error": _vm.error }] },
                    [_vm._v(_vm._s(_vm.error || _vm.notice))]
                  )
                : _vm._e(),
              _vm.status && _vm.status.configuredEnabled && !_vm.status.enabled
                ? _c("p", { staticClass: "receipt-note" }, [
                    _vm._v("已保存开启，当前尚未生效。"),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "p",
            {
              staticClass: "receipt-note",
              attrs: { id: "package-receipt-note" },
            },
            [
              _vm._v(
                "关闭后，未进入包裹收货流程的订单不再启用；已进入的订单仍可继续收货，记录保留。"
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }